import { NAME } from './constants';

export const LOAD_DEP_ARR_BY_CODE = `${NAME}/LOAD_DEP_ARR_BY_CODE`;
export const LOAD_DEP_ARR_SUCCESS = `${NAME}/LOAD_DEP_ARR_SUCCESS`;
export const LOAD_FAIL = `${NAME}/LOAD_FAIL`;
export const SET_DEPARR_AIRPORT = `${NAME}/SET_DEPARR_AIRPORT`;
export const SET_DEPARR_DATE_FIELD_INDEX = `${NAME}/SET_DEPARR_DATE_FIELD_INDEX`;
export const SET_SECONDARY_ACTION = `${NAME}/SET_SECONDARY_ACTION`;
